<template>
  <div>
    <translation :value="badge.name" :loading="loadingName" :id="badge.id" @save="saveName"></translation>
    <translation :value="badge.description" :loading="loadingDescription" :id="badge.id" @save="saveDescription"></translation>
    <translation :value="badge.successmessage" :loading="loadingSuccessMessage" :id="badge.id" @save="saveSuccessMessage"></translation>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import translation from '@/components/settings/translations/translations'

export default {
  props: ['id'],
  components: { translation },
  data () {
    return {
      loadingName: false,
      loadingDescription: false,
      loadingSuccessMessage: false
    }
  },
  computed: {
    ...mapGetters('account', {
      lang: 'defaultLang'
    }),
    ...mapGetters('badges', {
      getById: 'getById'
    }),
    badge () {
      return this.getById(this.id)
    }
  },
  methods: {
    ...mapActions('badges', ['updateBadge']),

    saveName (id) {
      this.loadingName = true

      if (!this.badge.name.fr) {
        delete this.badge.name.fr
      }
      if (!this.badge.name.en) {
        delete this.badge.name.en
      }

      this.save({id: this.badge.id, name: this.badge.name})
        .then(() => {
          this.loadingName = 'success'
        }).catch(() => {
          this.loadingName = 'failed'
        })
    },
    saveDescription (id) {
      this.loadingDescription = true

      if (!this.badge.description.fr) {
        delete this.badge.description.fr
      }
      if (!this.badge.description.en) {
        delete this.badge.description.en
      }

      this.save({id: this.badge.id, description: this.badge.description})
        .then(() => {
          this.loadingDescription = 'success'
        }).catch(() => {
          this.loadingDescription = 'failed'
        })
    },
    saveSuccessMessage (id) {
      this.loadingSuccessMessage = true

      if (!this.badge.successmessage.fr) {
        delete this.badge.successmessage.fr
      }
      if (!this.badge.successmessage.en) {
        delete this.badge.successmessage.en
      }

      this.save({id: this.badge.id, successmessage: this.badge.successmessage})
        .then(() => {
          this.loadingSuccessMessage = 'success'
        }).catch(() => {
          this.loadingSuccessMessage = 'failed'
        })
    },
    save (badge) {
      return this.updateBadge({badge: badge})
        .then(() => {
          this.$notify({title: 'Success', message: this.$root.$t('notifications.translations.edited'), type: 'success'})
        }).catch(() => {
          this.$notify.error({title: 'Error', message: this.$root.$t('notifications.unknown')})
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/translations/translations_badge.vue